// libraries
import isEqual from 'lodash/isEqual';
import type { paymentServicesTypes } from '@makemydeal/dr-platform-types';
import { actionCreators as offerReduxActionCreators, selectors as offerReduxSelectors } from '@makemydeal/dr-offer-redux';

// interfaces/types
import type { DashStoreThunk } from '../types/appState';

export const retainOverriddenTaxes =
    (retainedTaxes: paymentServicesTypes.TaxItem[]): DashStoreThunk =>
    (dispatch, getState) => {
        const state = getState();
        const offerType = offerReduxSelectors.getCurrentOfferType(state);
        const currentOverriddenTaxes = offerReduxSelectors.getManualTaxItems(state);
        const retainedTaxesByName = new Map(retainedTaxes.map((tax) => [tax.taxName, tax]));

        // Fully-dropped taxes are reset to computed values; partially-retained taxes are replaced
        // with the trimmed override the manager selected.
        const updatedTaxes = currentOverriddenTaxes.reduce<paymentServicesTypes.TaxItem[]>((acc, tax) => {
            const retained = retainedTaxesByName.get(tax.taxName);
            if (!retained) {
                // Assigned to a variable so the untyped isManualTaxRate/isManualTaxAmount flags aren't excess-property checked.
                const strippedTax = {
                    ...tax,
                    isManualTax: false,
                    isManualTaxRate: false,
                    isManualTaxAmount: false,
                    manualChanges: undefined
                };
                acc.push(strippedTax);
            } else if (!isEqual(retained, tax)) {
                acc.push(retained);
            }
            return acc;
        }, []);

        if (updatedTaxes.length > 0) {
            dispatch(offerReduxActionCreators.updateTaxItems(updatedTaxes, offerType, false));
        }
    };
